module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "base"
  }, [_c('section', {
    staticClass: "header",
    attrs: {
      "role": "region",
      "aria-label": "תפריט ראשי",
      "id": "headerC"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    attrs: {
      "id": "content-wrapper"
    }
  }, [_c('div', {
    staticClass: "header-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "menu-wrapper"
  }, [_c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "0",
      "role": "button"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.scrollToWorking()
      }
    }
  }, [_vm._v("איך זה עובד?")])]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "-1",
      "role": "none"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "0",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToGallery()
      }
    }
  }, [_c('a', [_vm._v("כך זה נראה")])]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "-1",
      "role": "none"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "0",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToTeam()
      }
    }
  }, [_c('a', [_vm._v("צוות החצר")])]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "-1",
      "role": "none"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "0",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToFaqs()
      }
    }
  }, [_c('a', [_vm._v("שאלות נפוצות")])]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "-1",
      "role": "none"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "0",
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleTalkToMe()
      }
    }
  }, [_c('a', [_vm._v("צור קשר")])]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "-1",
      "role": "none"
    }
  }, [_vm._v("|")]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "0",
      "role": "button"
    }
  }, [_c('v-link', {
    attrs: {
      "href": "/rhythm"
    }
  }, [_c('a', [_vm._v("רישום לאודישן")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auditionButtonOpen),
      expression: "auditionButtonOpen"
    }],
    staticClass: "menuAuditionButtons"
  }, [_c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('v-link', {
    attrs: {
      "href": "/rhythm"
    }
  }, [_c('a', [_vm._v("אודישן להרכב")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('v-link', {
    attrs: {
      "href": "/ensemble"
    }
  }, [_c('a', [_vm._v("אודישן לאנסמבל הקולי")])])], 1)])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "header-logo"
  }, [_c('div', {
    staticClass: "logo-img",
    style: ({
      height: _vm.logoHeaderHeight() + 'px'
    })
  }, [_c('img', {
    attrs: {
      "alt": "החצר",
      "id": "headerlogo",
      "src": "images/logo-and-tagline.png"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToHome()
      }
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "header-logo-mobile"
  }, [_c('div', {
    staticClass: "logo-mobile-img"
  }, [_c('img', {
    attrs: {
      "alt": "החצר",
      "id": "headermobilelogo",
      "src": "images/upper-logo---solo.png"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToHome()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "header-mobile-menu",
    attrs: {
      "role": "button",
      "aria-label": "menu"
    },
    on: {
      "click": function($event) {
        return _vm.showMenu()
      }
    }
  }, [_c('div', {
    staticClass: "divider"
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuVisible),
      expression: "menuVisible"
    }],
    staticClass: "menu-mobile-wrapper"
  }, [_c('div', {
    staticClass: "menuButton",
    attrs: {
      "role": "button"
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.scrollToWorking()
      }
    }
  }, [_vm._v("איך זה עובד?")])]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToGallery()
      }
    }
  }, [_c('a', [_vm._v("כך זה נראה")])]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToTeam()
      }
    }
  }, [_c('a', [_vm._v("צוות החצר")])]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.scrollToFaqs()
      }
    }
  }, [_c('a', [_vm._v("שאלות נפוצות")])]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleTalkToMe()
      }
    }
  }, [_c('a', [_vm._v("צור קשר")])]), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    attrs: {
      "role": "button"
    }
  }, [_c('v-link', {
    attrs: {
      "href": "/rhythm"
    }
  }, [_c('a', [_vm._v("רישום לאודישן")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auditionButtonOpen),
      expression: "auditionButtonOpen"
    }],
    staticClass: "menuAuditionButtons",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('div', {
    staticClass: "menuButton",
    attrs: {
      "role": "button"
    }
  }, [_c('v-link', {
    attrs: {
      "href": "/rhythm"
    }
  }, [_vm._v("אודישן להרכב")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuButton",
    staticStyle: {
      "margin-bottom": "-10px"
    },
    attrs: {
      "role": "button"
    }
  }, [_c('v-link', {
    attrs: {
      "href": "/ensemble"
    }
  }, [_vm._v("אודישן לאנסמבל")])], 1)])])], 1)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "talkToMeAligner"
  }, [_c('div', {
    staticClass: "talkToBackground"
  }, [_c('div', {
    staticClass: "talkToMeWrapper"
  }, [_c('TalkToMeHeader', {
    attrs: {
      "uid": "firstTalkToMeHeader"
    }
  })], 1)])]), _vm._v(" "), (_vm.showContactDialog) ? _c('TalkToMe', {
    attrs: {
      "auditionType": "Rhythm"
    },
    on: {
      "close": function($event) {
        return _vm.toggleTalkToMe()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "video-player"
    }
  }, [_c('div', {
    staticClass: "plyr__video-embed",
    attrs: {
      "id": "player"
    }
  }, [_c('iframe', {
    staticStyle: {
      "position": "absolute",
      "z-index": "8"
    },
    attrs: {
      "src": "https://www.youtube.com/embed/dE6I_2Ise7k?autoplay=1&iv_load_policy=3&modestbranding=0&playsinline=1showinfo=0&rel=0&enablejsapi=1?&autohide=1&controls=1&mute=1",
      "allowfullscreen": "",
      "allowtransparency": "",
      "allow": "autoplay",
      "id": "yuPlayer"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-title-mobile",
    attrs: {
      "role": "heading",
      "aria-level": "3",
      "aria-label": "subtitle"
    }
  }, [_c('div', [_vm._v("קהילה מקצועית למוסיקאים חובבים")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "footer",
    attrs: {
      "role": "region",
      "aria-label": "תחתית הדף",
      "id": "footerC"
    }
  }, [_c('div', {
    staticClass: "back-yards-credit"
  }, [_c('div', {
    staticClass: "footer-logo"
  }, [_c('div', {
    staticClass: "footer-logo-img"
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "alt": "החצר",
      "src": "images/site-bottom-logo.png"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "aria-label": "facebook (opens in a new page)",
      "target": "_blank",
      "href": "https://www.facebook.com/yardbands"
    }
  }, [_c('div', {
    staticClass: "footer-social",
    attrs: {
      "id": "social1"
    }
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "alt": "החצר בפייסבוק",
      "src": "images/social1.png"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "aria-label": "instagram (opens in a new page)",
      "target": "_blank",
      "href": "https://www.instagram.com/yardbands"
    }
  }, [_c('div', {
    staticClass: "footer-social",
    attrs: {
      "id": "social2"
    }
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "alt": "החצר באינסטגרם",
      "src": "images/social2.png"
    }
  })])]), _vm._v(" "), _c('a', {
    attrs: {
      "aria-label": "youtube channel (opens in a new page)",
      "target": "_blank",
      "href": "https://www.youtube.com/channel/UCSbxr9Lhw29M_cVdDDsW8EA/playlists"
    }
  }, [_c('div', {
    staticClass: "footer-social",
    attrs: {
      "id": "social3"
    }
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "alt": "החצר ביוטיוב",
      "src": "images/social3.png"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "contacts"
  }, [_c('p', [_c('strong', [_vm._v("\n\t\t\t\t\tהחצר צפון: "), _c('a', {
    attrs: {
      "href": "tel:0507731726"
    }
  }, [_vm._v("050-7731726")]), _vm._v("\n\t\t\t\t\t | "), _c('a', {
    attrs: {
      "href": "mailto:NOFFICE@YARDBANDS.COM"
    }
  }, [_vm._v("NOFFICE@YARDBANDS.COM")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tהחצר מרכז: "), _c('a', {
    attrs: {
      "href": "tel:0547737094"
    }
  }, [_vm._v("054-7737094")]), _vm._v("\n\t\t\t\t\t | "), _c('a', {
    attrs: {
      "href": "mailto:OFFICE@YARDBANDS.COM"
    }
  }, [_vm._v("OFFICE@YARDBANDS.COM")]), _vm._v(" "), _c('br'), _vm._v("\n\t\t\t\t\tכל הזכויות שמורות לחצר\n\t\t\t\t\t")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "aria-label": "privacy policy (opens in a new page)",
      "target": "_blank",
      "href": "http://yard-bands.herokuapp.com/privacyPolicy.pdf"
    }
  }, [_c('strong', [_vm._v("מדיניות פרטיות")])]), _vm._v("|\n\t\t\t\t\t"), _c('a', {
    attrs: {
      "aria-label": "usage conditions (opens in a new page)",
      "target": "_blank",
      "href": "http://yard-bands.herokuapp.com/privacyPolicy.pdf"
    }
  }, [_c('strong', [_vm._v("תנאי שימוש")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "credits",
    attrs: {
      "role": "navigation",
      "aria-label": "קרדיט"
    }
  }, [_c('p', [_c('strong', [_c('a', {
    staticStyle: {
      "color": "#FF632B"
    },
    attrs: {
      "href": "https://www.designninjas.org"
    }
  }, [_vm._v("DESIGN: DOVEV ALPERSON (DESIGN NINJAS)")]), _vm._v(" | CODE BY YUVAL DERI (PARAREACH) | PHOTOGRAPY BY ILAN BURLA")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15c7083d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Main.vue
// module id = 102
// module chunks = 0